import axios from "axios";
import { env } from "../../config/env";
import { normalizeApiError } from "./error";

function buildRequestUrl(baseUrl, path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (baseUrl.includes("?rest_route=")) {
    return `${baseUrl}${normalizedPath}`;
  }

  return `${baseUrl.replace(/\/$/, "")}${normalizedPath}`;
}

async function executeGet({ url, params, signal }) {
  const response = await axios.get(url, {
    params,
    signal,
    timeout: env.requestTimeoutMs,
  });

  return response.data;
}

function shouldTryNextCandidate(error) {
  if (!error?.response) {
    return true;
  }

  return [404, 500, 502, 503].includes(error.response.status);
}

export async function getFirstSuccessfulResponse({
  baseUrls,
  pathCandidates,
  params,
  signal,
}) {
  let lastError = null;

  for (const path of pathCandidates) {
    for (const baseUrl of baseUrls) {
      const url = buildRequestUrl(baseUrl, path);

      try {
        const data = await executeGet({ url, params, signal });

        return { data, url };
      } catch (error) {
        lastError = normalizeApiError(error, url);

        if (!shouldTryNextCandidate(error)) {
          throw lastError;
        }
      }
    }
  }

  throw lastError || normalizeApiError(new Error("Unknown API error"), "");
}
